import {inject, injectable} from 'inversify';

import type {DateTimeModel} from '../../../../core/domain/Date/DateTime.model';

import {MetricModel} from '../../../../core/domain/Metric/Metric.model';
import {logger} from '../../../../utils/logger';
import {TrackWeightCmd} from '../ports/TrackWeight/TrackWeight.cmd';

@injectable()
export class TrackWeightUseCase {
  constructor(
    @inject(TrackWeightCmd)
    private readonly command: TrackWeightCmd,
  ) {}

  async exec({
    date,
    unit,
    weight,
  }: TrackWeightUseCase.Props): Promise<TrackWeightUseCase.Response> {
    try {
      const weightKg =
        unit === 'lbs' ? MetricModel.poundsToKilogram(weight) : weight;

      return this.command.exec({
        date,
        weightKg,
      });
    } catch (e) {
      logger.error(e);

      throw e;
    }
  }
}

export namespace TrackWeightUseCase {
  export type Props = {
    date: DateTimeModel;
    unit: MetricModel.WeightUnit;
    weight: number;
  };
  export type Response = TrackWeightCmd.Response;
}
